import React, {Component} from 'react';
import {Link} from 'react-router-dom';

export default class NotFound extends Component {
	render() {
		document.body.classList.add("pace-done");
		return (
			<section>
				<h1>404</h1>
				<Link to={process.env.APP_ROOT}>Go back</Link>
			</section>
		);
	}
}
